import React from 'react'
import {
  ButtonGroup,
  ButtonGroupItem,
  Paragraph,
} from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { ContractTenant } from '../../../../../common/validations'
import { getTenantName } from '../../../../utils/getTenantName'
import { LockedTenantChoice } from '../LockedTenantChoice/LockedTenantChoice'
import { resolveTenantRoleLabel } from './resolveTenantRoleLabel'

export type TenantChoiceState =
  | { type: 'locked'; label: string }
  | {
      type: 'select'
      suggestions: ButtonGroupItem[]
      value: string
      onChange: (value: string | undefined) => void
    }

type TenantChoiceProps = {
  tenant: ContractTenant
  isCurrentUser: boolean
  choice: TenantChoiceState
}

export const TenantChoice: React.FC<TenantChoiceProps> = ({
  tenant,
  isCurrentUser,
  choice,
}) => {
  const { t } = useTranslation(['contractModification'])
  const name = getTenantName(tenant)
  const roleLabel = resolveTenantRoleLabel(tenant)

  return (
    <div className="mb-4 flex items-center justify-between phone:flex-col phone:items-stretch">
      <div>
        <Paragraph>
          {isCurrentUser
            ? t('contractModification:tenantChoices.currentUserName', { name })
            : name}
        </Paragraph>
        {roleLabel && (
          <Paragraph small light>
            {roleLabel}
          </Paragraph>
        )}
      </div>
      <div className="mt-2 w-80 shrink-0 phone:w-full">
        {choice.type === 'locked' ? (
          <LockedTenantChoice label={choice.label} tenantName={name} />
        ) : (
          <ButtonGroup
            className="w-full"
            onChange={choice.onChange}
            suggestions={choice.suggestions}
            value={choice.value}
            sameSize
            aria-label={name}
            data-testid="tenantSelector"
          />
        )}
      </div>
    </div>
  )
}
